import type { HpSvgIconTypes } from '@avantia/style-guide';

import { HpAlert } from 'components/shared/alert';
import { ExternalLink } from 'components/shared/externalLink';
import { EXTERNAL_PATH } from 'interfaces/pathTypes';

import './accountMessage.scss';
import { POLICY_LIFECYCLE_STATUS, PolicyLifecycleStatus } from 'interfaces/customerDataTypes';

interface AccountMessageProps {
  policyLifecycleStatus: PolicyLifecycleStatus;
}
export interface RenewalDisplayWarning {
  title?: string;
  message?: JSX.Element;
}

export const getRenewalDisplayWarning = (policyLifecycleStatus: PolicyLifecycleStatus): RenewalDisplayWarning => {
  switch (policyLifecycleStatus) {
    case POLICY_LIFECYCLE_STATUS.POLICY_RENEWAL_QUOTE:
    case POLICY_LIFECYCLE_STATUS.POLICY_RENEWAL_NOCONVERSION:
    case POLICY_LIFECYCLE_STATUS.POLICY_RENINVITE_WITHDRAWN:
    case POLICY_LIFECYCLE_STATUS.POLICY_MTAQUOTE:
    case POLICY_LIFECYCLE_STATUS.POLICY_MTAQUOTEINVITED:
    case POLICY_LIFECYCLE_STATUS.POLICY_MTA_NOCONVERSION:
      return {
        title: 'Please give us a call',
        message: (
          <p className="account-message-text">
            We need to speak with you before renewing this policy. Please call us on 0330 660 1000.
          </p>
        )
      };
    case POLICY_LIFECYCLE_STATUS.POLICY_RENEWAL_SCHEDULED:
      return {
        title: 'Renewal in progress',
        message: (
          <p className="account-message-text">
            Your renewal is being processed. Get in{' '}
            <ExternalLink href={EXTERNAL_PATH.CONTACT_US} id="contact-us" className="link-text">
              contact with us here
            </ExternalLink>{' '}
            to amend this policy.
          </p>
        )
      };
    case POLICY_LIFECYCLE_STATUS.POLICY_LIVE_EXPIRING:
      return {
        title: 'Policy expired',
        message: (
          <p className="account-message-text">
            Your policy has now expired. To reinstate your cover,{' '}
            <ExternalLink href={EXTERNAL_PATH.CONTACT_US} id="contact-us" className="link-text">
              contact us
            </ExternalLink>{' '}
            or purchase a new policy.
          </p>
        )
      };
    default:
      return {};
  }
};

export const AccountMessage = ({ policyLifecycleStatus }: AccountMessageProps): JSX.Element => {
  const { message, title } = getRenewalDisplayWarning(policyLifecycleStatus);
  return (
    <>
      {title && message && (
        <HpAlert
          iconType={'info' as HpSvgIconTypes}
          alertLevel="error"
          message={message}
          header={title}
          className="account-message-alert"></HpAlert>
      )}
    </>
  );
};
